import { TypedDocumentNode } from '@graphql-typed-document-node/core';
import { GraphQLClientRequestHeaders } from 'graphql-request/build/esm/types';
import { print } from 'graphql';

export default async function queryDatoCMS<
  TResult = unknown,
  TVariables = Record<string, any>
>(
  document: TypedDocumentNode<TResult, TVariables> | string,
  variables?: TVariables,
  isDraft?: boolean
): Promise<TResult> {
  const headers: GraphQLClientRequestHeaders = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'X-Exclude-Invalid': 'true',
    Authorization: `Bearer ${process.env.DATOCMS_READONLY_API_TOKEN}`,
  };

  if (isDraft) headers['X-Include-Drafts'] = 'true';

  try {
    const response = await fetch('https://graphql.datocms.com/', {
      cache: 'force-cache',
      next: { tags: ['datocms'] },
      method: 'POST',
      headers,
      body: JSON.stringify({
        query: typeof document === 'string' ? document : print(document as any),
        variables,
      }),
    });

    if (!response.ok) {
      console.error(`DatoCMS API error: ${response.status} ${response.statusText}`);
      throw new Error(`DatoCMS API returned ${response.status}`);
    }

    const json = await response.json();

    if (json.errors) {
      console.error('DatoCMS GraphQL errors:', json.errors);
      throw new Error(`GraphQL errors: ${JSON.stringify(json.errors)}`);
    }

    return json.data;
  } catch (error) {
    console.error('Error querying DatoCMS:', error);
    throw error; // Re-throw to let calling code handle with notFound()
  }
}
